const registerAccount = (email) => {
	console.log(`Registering with email: ${email}`);
	return new Promise((resolve, reject) => {
		fetch("/api/accounts", {
			method: "POST",
			body: JSON.stringify({email}),
			headers: {"Content-Type": "application/json"}
		}).then((response) => {
			if (response.status === 201) {
				const location = response.headers.get("Location");
				console.log(`User created at location: ${location}`);
				resolve(location);
			} else if (response.status === 400) {
				response.json().then((json) => {
					console.log(`Invalid registration request: ${json.errorCodes}`);
					reject({
						reason: "invalid",
						status: response.status,
						errorCodes: json.errorCodes
					});
				});
			} else {
				console.log(`Registration request failed with status ${response.status}`);
				reject({reason: "status", status: response.status});
			}
		});
	});
};

export {registerAccount};


// WEBPACK FOOTER //
// ./src/services/AccountService.js